"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _rtlDetect = require("rtl-detect");

var contentful = _interopRequireWildcard(require("contentful"));

var _richTextReactRenderer = require("@contentful/rich-text-react-renderer");

var _constants = require("./constants.js");

var _common = require("./common.js");

var _frameComponent = _interopRequireDefault(require("./frame-component.js"));

var _utilFunctions = require("./utilFunctions");

var _cookiePopupThemes = _interopRequireDefault(require("./cookie-popup-themes"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CookiePopup =
/*#__PURE__*/
function (_FrameComponent) {
  _inherits(CookiePopup, _FrameComponent);

  function CookiePopup(props) {
    var _this;

    _classCallCheck(this, CookiePopup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CookiePopup).call(this, props)); // Connecting to Contentful

    _this.client = contentful.createClient({
      space: 'kp51zybwznx4',
      environment: 'master',
      accessToken: 'dpk-7L7rGYzkKk-jZwtIDnyhui6DgLq6VTapJNI7W44'
    });
    _this.callInitCookiePopup = _this.callInitCookiePopup.bind(_assertThisInitialized(_this));
    _this.enablePerformanceAnalytics = _this.enablePerformanceAnalytics.bind(_assertThisInitialized(_this));
    _this.state = {
      userLocation: null,
      globalCookieBannerData: null
    };
    _this.ga = CookiePopup.getGaidWithPrefix(props.GAID);
    _this.rtlLangs = ['ar', 'ur-PK'];
    return _this;
  }

  _createClass(CookiePopup, [{
    key: "callInitCookiePopup",
    value: function callInitCookiePopup(popupContainerElement) {
      var _this2 = this;

      var _this$props = this.props,
          marketingAnalyticsCallback = _this$props.marketingAnalyticsCallback,
          propsCookieDomain = _this$props.cookieDomain;
      var cookieDomain = (0, _utilFunctions.getCookieDomain)(propsCookieDomain);

      var enableAnalytics = function enableAnalytics() {
        _this2.enablePerformanceAnalytics();

        marketingAnalyticsCallback();
      };

      (0, _common.initCookiePolicyPopup)(popupContainerElement, cookieDomain, enableAnalytics);
    }
  }, {
    key: "enablePerformanceAnalytics",
    value: function enablePerformanceAnalytics() {
      var _this$props2 = this.props,
          GTMID = _this$props2.GTMID,
          GAID = _this$props2.GAID,
          plugins = _this$props2.plugins,
          gaCustomCallback = _this$props2.gaCustomCallback,
          gtmCustomCallback = _this$props2.gtmCustomCallback,
          performanceAnalyticsCallback = _this$props2.performanceAnalyticsCallback;

      if (GTMID && GAID) {
        (0, _utilFunctions.enableGoogleTagManager)(GTMID, this.ga, gtmCustomCallback);
      } else if (GAID) {
        (0, _utilFunctions.enableGoogleAnalytics)(this.ga, plugins, gaCustomCallback);
      }

      performanceAnalyticsCallback();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      var _this$props3 = this.props,
          marketingAnalyticsCallback = _this$props3.marketingAnalyticsCallback,
          locale = _this$props3.locale,
          onError = _this$props3.onError; // Getting data from Contentful

      this.client.getEntries({
        content_type: 'cookieBanner',
        locale: locale
      }).then(function (entries) {
        var _entries$items = _slicedToArray(entries.items, 1),
            fields = _entries$items[0].fields;

        _this3.setState({
          globalCookieBannerData: fields
        });
      })["catch"](function (err) {
        if (onError) {
          onError(err);
        } // If something goes wrong we do not render the global cookie banner


        _this3.setState({
          globalCookieBannerData: null
        });
      });
      window["ga-disable-".concat(this.ga)] = true; // GTM will fire triggers and set third party pixels based on variables such as countryRegion

      fetch('https://www.snapchat.com/cookies/api/user_location').then(function (res) {
        if (res.status !== 200) {
          var status = res.status,
              statusText = res.statusText;
          throw new Error("".concat(status, " : ").concat(statusText));
        }

        return res.json();
      }).then(function (userLocation) {
        var _window$dataLayer;

        var country = userLocation.country,
            region = userLocation.region;
        var countryRegion = "".concat(country, "-").concat(region);
        window.dataLayer = (_window$dataLayer = window.dataLayer) !== null && _window$dataLayer !== void 0 ? _window$dataLayer : [];
        dataLayer.push({
          userLocation: countryRegion
        });

        _this3.setState({
          userLocation: userLocation
        }, function () {
          if ((0, _utilFunctions.__getCookie)('Performance') === 'true') {
            _this3.enablePerformanceAnalytics();
          }

          if ((0, _utilFunctions.__getCookie)('Marketing') === 'true') {
            marketingAnalyticsCallback();
          }
        });
      })["catch"](function (err) {
        if (onError) {
          onError(err);
        }
      });
    }
  }, {
    key: "renderContainerStyles",
    value: function renderContainerStyles(dir) {
      /* eslint-disable max-len */
      var encodedSvgCloseIcon = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20style%3D%22background-color%3A%20lightgray%3B%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2030%2030%22%3E%3Crect%20width%3D%223%22%20height%3D%2220%22%20x%3D%2213.5%22%20y%3D%225%22%20fill%3D%22%23FFF%22%20rx%3D%221%22%20ry%3D%221%22%3E%3C%2Frect%3E%3Crect%20width%3D%2220%22%20height%3D%223%22%20y%3D%2213.5%22%20x%3D%225%22%20fill%3D%22%23FFF%22%20rx%3D%221%22%20ry%3D%221%22%3E%3C%2Frect%3E%3C%2Fsvg%3E';
      var encodedSvgCloseIconHover = 'data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20style%3D%22background-color%3A%20gray%3B%22%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2030%2030%22%3E%3Crect%20width%3D%223%22%20height%3D%2220%22%20x%3D%2213.5%22%20y%3D%225%22%20fill%3D%22%23FFF%22%20rx%3D%221%22%20ry%3D%221%22%3E%3C%2Frect%3E%3Crect%20width%3D%2220%22%20height%3D%223%22%20y%3D%2213.5%22%20x%3D%225%22%20fill%3D%22%23FFF%22%20rx%3D%221%22%20ry%3D%221%22%3E%3C%2Frect%3E%3C%2Fsvg%3E';
      /* eslint-enable max-len */

      var themedStyles = _cookiePopupThemes["default"][this.props.theme];
      return "\n      #".concat(this.props.containerID, " {\n        ").concat(themedStyles.container, "\n        position: fixed;\n        display: flex;\n        align-items: center;\n        width: 100%;\n        min-height: 33%;\n        z-index: 1000;\n        bottom: 0;\n\n        font-size: 14px;\n        line-height: 17px;\n\n        transition: transform, box-shadow;\n        transition-duration: 500ms;\n        transition-timing-function: cubic-bezier(0,0,0,1), linear;\n        transform: translateY(100%);\n        -webkit-transform: translateY(100%);\n        box-shadow: 0 0 0 rgba(0,0,0,0.075);\n      }\n\n      #").concat(this.props.containerID, ".shown {\n        transform: translateY(0);\n        -webkit-transform: translateY(0);\n        box-shadow: 0 -1px 3px rgba(0,0,0,0.175);\n      }\n\n      #").concat(this.props.containerID, " #cookiePopupCloseButton {\n        position: absolute;\n        right: 30px;\n        top: calc(50% - 10px);\n        border-radius: 50%;\n        width: 20px;\n        height: 20px;\n        background-color: lightgray;\n        cursor: pointer;\n        transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        -webkit-transform: rotate(45deg);\n        background: url(").concat(encodedSvgCloseIcon, ");\n      }\n\n      #").concat(this.props.containerID, " #cookiePopupCloseButton:hover {\n        background: url(").concat(encodedSvgCloseIconHover, ");\n      }\n\n      #").concat(this.props.containerID, " #cookiePopupAcceptEU {\n        ").concat(themedStyles.button, "\n        font-family: AvenirNext, sans-serif;\n        font-size: 14px;\n        line-height: 16px;\n        padding: 8px 20px;\n        margin-top: 10.5px;\n        border: none;\n        outline: none;\n        border-radius: 100px;\n        cursor: pointer;\n        ").concat(dir === 'rtl' ? 'margin-left: 20px' : '', "\n      }\n\n      #").concat(this.props.containerID, " button {\n        margin-right: 20px;\n      }\n\n      #").concat(this.props.containerID, " a {\n        text-decoration: none;\n        color: #3cb2e2;\n      }\n\n      #").concat(this.props.containerID, " .cookie-text {\n        font-size: 14px;\n        line-height: 23px;\n        padding: 28px 20px 0;\n        margin-left: calc(10% + 210px);\n        margin-right: calc(10% + 210px);\n      }\n\n      #").concat(this.props.containerID, " .cookie-prompt-eu {\n        padding-bottom: 28px;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n      }\n\n      @media (min-width: 768px) {\n        #").concat(this.props.containerID, " .cookie-text {\n          padding-bottom: 20px;\n        }\n      }\n\n      @media (max-width: 1200px) {\n        #").concat(this.props.containerID, " .cookie-text {\n          margin-left: 3%;\n          margin-right: calc(3% + 40px);\n        }\n      }\n\n      @media (max-width: 1200px) {\n        #").concat(this.props.containerID, " .cookie-icon {\n          display: none;\n        }\n      }\n\n      @media print {\n        #").concat(this.props.containerID, " {\n          display: none;\n        }\n      }\n\n      @media (max-width: 767px) {\n        #").concat(this.props.containerID, " .cookie-text {\n          font-size: 10px;\n          line-height: 16px;\n          text-align: center;\n        }\n      }\n\n      @media (max-width: 360px) {\n        #").concat(this.props.containerID, " #cookiePopupAcceptEU {\n          font-size: 12.5px;\n        }\n\n        #cookiePopupContainer button {\n          margin-right: 15px;\n        }\n\n        #").concat(this.props.containerID, " #cookiePopupSettings {\n          padding-top: 10px;\n          font-size: 12.5px;\n        }\n      }\n    ");
    }
  }, {
    key: "getCookieIconStyle",
    value: function getCookieIconStyle() {
      return {
        position: 'absolute',
        width: 240,
        height: 120,
        backgroundSize: 'cover'
      };
    }
  }, {
    key: "renderLeftCookieIcon",
    value: function renderLeftCookieIcon(media) {
      if (!media.fields.file.url) {
        return null;
      }

      var cookieIconStyle = Object.assign({}, this.getCookieIconStyle(), {
        left: 'calc(10% - 50px)',
        top: 'calc(50% - 55px)',
        background: "url(\"https:".concat(media.fields.file.url, "\") center center no-repeat")
      });
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "cookie-icon cookie-icon-left",
          style: cookieIconStyle
        })
      );
    }
  }, {
    key: "renderRightCookieIcon",
    value: function renderRightCookieIcon(media) {
      if (!media.fields.file.url) {
        return null;
      }

      var cookieIconStyle = Object.assign({}, this.getCookieIconStyle(), {
        right: 'calc(10% - 50px)',
        top: 'calc(50% - 50px)',
        background: "url(\"https:".concat(media.fields.file.url, "\") center center no-repeat")
      });
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "cookie-icon cookie-icon-right",
          style: cookieIconStyle
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.userLocation) {
        return null;
      } // If the Contentful data is not present we do not render anything


      if (!this.state.globalCookieBannerData) {
        return null;
      }

      var _this$state$globalCoo = this.state.globalCookieBannerData,
          leftMedia = _this$state$globalCoo.leftMedia,
          rightMedia = _this$state$globalCoo.rightMedia,
          body = _this$state$globalCoo.body,
          acceptCookiesButton = _this$state$globalCoo.acceptCookiesButton,
          cookieSettingsButtonText = _this$state$globalCoo.cookieSettingsButtonText; // Converting body data to React component

      var content = (0, _richTextReactRenderer.documentToReactComponents)(body);
      var gettext = this.createStringSelector();
      var cookieTextMarkup = {
        __html: gettext('COOKIE_POPUP_EU').replace('{COOKIE_POLICY_URL}', this.props.cookiePolicyUrl)
      }; // Direction: left to right by default

      var dir = (0, _rtlDetect.getLangDir)(this.props.locale);
      return (
        /*#__PURE__*/
        _react["default"].createElement("div", {
          id: this.props.containerID,
          className: this.props.className,
          ref: this.callInitCookiePopup
        },
        /*#__PURE__*/
        _react["default"].createElement("style", null, this.renderContainerStyles(dir)), this.renderLeftCookieIcon(leftMedia),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "cookie-popup"
        },
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "cookie-text",
          dir: dir
        }, content),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          className: "cookie-prompt-eu"
        },
        /*#__PURE__*/
        _react["default"].createElement("button", {
          id: "cookiePopupAcceptEU"
        }, acceptCookiesButton),
        /*#__PURE__*/
        _react["default"].createElement("a", {
          href: this.props.cookieSettingsUrl,
          id: "cookiePopupSettings"
        }, cookieSettingsButtonText))), this.renderRightCookieIcon(rightMedia),
        /*#__PURE__*/
        _react["default"].createElement("div", {
          id: "cookiePopupCloseButton",
          "aria-label": "Close Cookie Popup"
        }))
      );
    }
  }]);

  return CookiePopup;
}(_frameComponent["default"]);

exports["default"] = CookiePopup;

_defineProperty(CookiePopup, "propTypes", {
  domain: _propTypes["default"].string,
  cookieDomain: _propTypes["default"].string,
  cookiePolicyUrl: _propTypes["default"].string,
  leftCookieIconSrc: _propTypes["default"].string,
  rightCookieIconSrc: _propTypes["default"].string,
  containerID: _propTypes["default"].string,
  className: _propTypes["default"].string,
  cookieSettingsUrl: _propTypes["default"].string,
  GTMID: _propTypes["default"].string,
  GAID: _propTypes["default"].string,
  plugins: _propTypes["default"].array,
  gaCustomCallback: _propTypes["default"].func,
  gtmCustomCallback: _propTypes["default"].func,
  performanceAnalyticsCallback: _propTypes["default"].func,
  marketingAnalyticsCallback: _propTypes["default"].func,
  theme: _propTypes["default"].oneOf(Object.keys(_cookiePopupThemes["default"])),
  onError: _propTypes["default"].func
});

_defineProperty(CookiePopup, "defaultProps", {
  domain: _constants.DEFAULT_DOMAIN,
  cookieDomain: '',
  cookiePolicyUrl: _constants.DEFAULT_COOKIE_POLICY_URL,
  leftCookieIconSrc: _constants.DEFAULT_COOKIE_ICON_LEFT,
  rightCookieIconSrc: _constants.DEFAULT_COOKIE_ICON_RIGHT,
  containerID: 'cookiePopupContainer',
  className: null,
  GTMID: '',
  GAID: '',
  plugins: [],
  gaCustomCallback: function gaCustomCallback() {},
  gtmCustomCallback: function gtmCustomCallback() {},
  performanceAnalyticsCallback: function performanceAnalyticsCallback() {},
  marketingAnalyticsCallback: function marketingAnalyticsCallback() {},
  theme: 'Light'
});

_defineProperty(CookiePopup, "getGaidWithPrefix", function (GAID) {
  if (GAID.includes('UA-') || GAID.includes('G-')) {
    return GAID;
  }

  return "UA-".concat(GAID);
});